import { STORAGE_KEY, STORYGRAPH_PILL_STYLE, type TransferData } from '../../constants'
import { parseLibbyPage } from './parser'
import { getUserOptions } from '../settings'
import { maybeDownloadCover } from '../../utils/download'

function openStoryGraphSearch (data: TransferData): void {
  const query = data.isbn || data.title
  const url = `https://app.thestorygraph.com/browse?search_term=${encodeURIComponent(query)}`
  if (typeof GM_openInTab === 'function') {
    GM_openInTab(url, { active: true })
  } else {
    window.open(url, '_blank')
  }
}

function getLibbyButtonHost (): HTMLElement | null {
  return (
    document.querySelector<HTMLElement>('div.screen-title-details-under-cover') ||
    document.querySelector<HTMLElement>('[data-testid="title-and-author"]')
  )
}

function isLikelyBookSurface (): boolean {
  if (getLibbyButtonHost()) return true

  const path = window.location.pathname
  return path.includes('/shelf/') && /\/\d+\/?$/.test(path)
}

function createPortButton (): HTMLAnchorElement {
  const btn = document.createElement('a')
  btn.id = 'libby-port-to-sg-btn'
  btn.href = '#'
  btn.textContent = 'Port to StoryGraph'
  btn.style.cssText = STORYGRAPH_PILL_STYLE
  return btn
}

export function injectLibbyPortButton (): void {
  if (!isLikelyBookSurface()) return
  if (!document.body) return

  const host = getLibbyButtonHost()
  if (!host) return

  const existing = document.getElementById('libby-port-to-sg-btn') as HTMLAnchorElement | null
  if (existing) {
    if (existing.parentElement !== host) host.appendChild(existing)
    return
  }

  const btn = createPortButton()
  host.appendChild(btn)

  btn.addEventListener('click', (event) => {
    event.preventDefault()
    const data = parseLibbyPage()
    const options = getUserOptions()

    if (options.downloadLibbyCover) {
      maybeDownloadCover(data.title, data.coverUrl)
    }

    GM_setValue(STORAGE_KEY, JSON.stringify(data))
    openStoryGraphSearch(data)
  })
}
